import useFetch from 'utils/hooks/useFetch'
import { ApiDeleteExpense, ApiGetExpense, ApiGetExpenseList, ApiInsertExpense, ApiUpdateExpense } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function ExpenseService() {
    const { showFail } = useModal()

    const { fetch: apiInsertExpense } = useFetch(ApiInsertExpense)
    const { fetch: apiUpdateExpense } = useFetch(ApiUpdateExpense)
    const { fetch: apiDeleteExpense } = useFetch(ApiDeleteExpense)
    const { fetch: apiGetExpenseById } = useFetch(ApiGetExpense)
    const { fetch: apiGetExpenseList } = useFetch(ApiGetExpenseList)
 
    const fetchCreateExpense = async (expenseDate, expenseCategory, amount, remark) => {
        const res = await apiInsertExpense({
            data: {
                expenseDate,
                expenseCategory,
                amount,
                remark
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateExpense = async (expenseId, expenseDate, expenseCategory, amount, remark) => {
        const res = await apiUpdateExpense({
            data: {
                expenseId,
                expenseDate,
                expenseCategory,
                amount,
                remark
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteExpense = async (expenseId, status) => {
        const res = await apiDeleteExpense({
            data: {
                expenseId, 
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchExpenseById = async (expenseId) => {
        const res = await apiGetExpenseById({
            data: {
                expenseId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchExpenseList = async (dateFrom, dateTo, status, pageSize, pageIndex) => {
        const res = await apiGetExpenseList({
            data: {
                dateFrom,
                dateTo,
                status,
                pageSize,
                pageIndex,
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    
    return {
        fetchCreateExpense,
        fetchUpdateExpense,
        fetchDeleteExpense,
        fetchExpenseById,
        fetchExpenseList,
    }
}